export default __webpack_public_path__ + "static/media/transfer-epoint-step5.8cef0b82.png";